var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#EFFFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 17.25H16.25C14.5931 17.25 13.25 18.5931 13.25 20.25V26.25C13.25 27.9069 14.5931 29.25 16.25 29.25H26.75C28.4069 29.25 29.75 27.9069 29.75 26.25V20.25C29.75 18.5931 28.4069 17.25 26.75 17.25Z",
    stroke: "#008000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17.25H26.75C27.5456 17.25 28.3087 17.5661 28.8713 18.1287C29.4339 18.6913 29.75 19.4544 29.75 20.25C29.75 21.0456 29.4339 21.8087 28.8713 22.3713C28.3087 22.9339 27.5456 23.25 26.75 23.25H16.25C15.4544 23.25 14.6913 22.9339 14.1287 22.3713C13.5661 21.8087 13.25 21.0456 13.25 20.25C13.25 19.4544 13.5661 18.6913 14.1287 18.1287C14.6913 17.5661 15.4544 17.25 16.25 17.25V17.25Z",
    stroke: "#008000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12.75H23.75C24.3467 12.75 24.919 12.9871 25.341 13.409C25.7629 13.831 26 14.4033 26 15V17.25H17V15C17 14.4033 17.2371 13.831 17.659 13.409C18.081 12.9871 18.6533 12.75 19.25 12.75V12.75Z",
    stroke: "#008000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRole);
export default __webpack_public_path__ + "static/media/dashboardRole.95e680e49d8a62ddf7d017f56ef83f0a.svg";
export { ForwardRef as ReactComponent };